export default function StepsSection() {
  const steps = [
    {
      icon: 'https://awkngtv.com/wp-content/uploads/2024/03/icons-2.png',
      title: 'Order',
      description: 'After placing your order, your access credentials and setup instructions will be sent instantly to your email inbox'
    },
    {
      icon: 'https://awkngtv.com/wp-content/uploads/2024/03/icons-3.png',
      title: 'Install',
      description: 'Follow the configuration instructions for each device you want to use, or our support team will completely assist you with setup time: 1 to 2 min'
    },
    {
      icon: 'https://awkngtv.com/wp-content/uploads/2024/03/icons-1.png',
      title: 'Enjoy',
      description: 'Experience optimized entertainment on your TV, Firestick, smartphone or computer'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            3 Easy Steps To Get Started With Goodys Streams
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="text-center bg-gray-50 rounded-xl p-8 hover:shadow-lg transition-shadow duration-300">
              <div className="mb-6">
                <img 
                  src={step.icon}
                  alt={step.title}
                  className="w-24 h-12 mx-auto object-contain"
                />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">
                {step.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
